module.exports = __webpack_public_path__ + "img/saddle-cloths-15.5dd5504a.svg";